const ptRegex = /P(\d+D)?T(\d+H)?(\d+M)?(\d+S)?/;

function parseInt(str) {
  if (str === undefined) return 0;
  return Number.parseInt(str, 10);
}

export function isoDurationToMinutes(
  duration, // e.g. 'PT10H30M10S'
  defaultValue = 0
) {
  if (!duration) return defaultValue;
  const match = ptRegex.exec(duration);
  if (match) {
    return (parseInt(match[1]) * 24 + parseInt(match[2])) * 60 + parseInt(match[3]);
  }
  return defaultValue;
}

export function isOfficialInformationTouched(info) {
  if (info.licenseId && info.licenseId.length > 0) {
    return true;
  }
  if (info.licenseDeliveryDate) {
    return true;
  }
  if (info.idCardNumber && info.idCardNumber.length > 0) {
    return true;
  }
  if (info.birthDate) {
    return true;
  }
  if (info.nationality && info.nationality.length > 0) {
    return true;
  }
  if (info.validity) {
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/public/journey1/definition/helper.js